import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from '@/router';
import store from '@/store';

Vue.use(VueRouter);

export const router = new VueRouter({
  mode: 'history',
  routes,
});

function setQueryCredentials(query) {
  if (query.client_id && query.expiry && query.token && query.uid) {
    localStorage.setItem('access-token', query.token);
    localStorage.setItem('client', query.client_id);
    localStorage.setItem('uid', query.uid);
    localStorage.setItem('expiry', query.expiry);
  }
}

function setAlert(query) {
  if (query.reset_password) {
    store.commit('alert/SUCCESS', 'You may now change your password!');
  }

  if (query.account_confirmation_success) {
    store.commit('alert/SUCCESS', 'Email successfully confirmed!');
  }

  // if (query.account_confirmation_success) {
  //   store.commit('alert/SUCCESS', 'Email successfully changed!');
  // }
}

router.beforeEach((to, from, next) => {
  store.commit('alert/CLEAR');

  setQueryCredentials(to.query);
  setAlert(to.query);

  const requiresAuth = to.matched.some(m => m.meta.auth);
  const skippable = to.matched.some(m => m.meta.skippable);
  const currentUser = store.state.auth.currentUser;

  if (requiresAuth && !currentUser) {
    next({ name: 'login' });
  } else if (!requiresAuth && currentUser) {
    if (currentUser.data.attributes.birthday === null) {
      next({ name: 'setup' });
    } else if (skippable) {
      next({ name: 'home' });
    } else {
      next();
    }
  } else if (requiresAuth && currentUser) {
    if (currentUser.data.attributes.birthday === null) {
      if (to.name === 'setup') {
        next();
      } else {
        next({ name: 'setup' });
      }
    } else {
      next();
    }
  } else {
    next();
  }
});

Vue.router = router;

export default {
  router,
};



// WEBPACK FOOTER //
// ./src/plugins/vue-router.js